import { createReducer, on } from '@ngrx/store';
import {
  LoadSchemaProjects,
  LoadCurrentSchemaProject,
  LoadCurrentSchema,
  LoadActiveSchema,
  CreateSchema,
  CreateSchemaProject,
  DeleteSchemaProject,
  RemoveSchemaError,
  SetSchemaDefinitions,
  SetSchemaDefinitionVersions,
  SetSchemaDefinition,
  SetSchemaProjects,
  SetCurrentSchemaProject,
  LoadCurrentSchemas,
  SetCurrentSchemas,
  SetCurrentSchema,
  SetActiveSchema,
  SetSchemaError,
} from './schema.actions';
import { SchemaApiError } from './schema.errors';
import { SchemaProject } from 'src/app/admin/models/schema-project.model';
import { Schema } from 'src/app/admin/models/schema.model';
import { SchemaDefinition } from 'src/app/admin/models/schema-definition.model';

export interface SchemaState {
  projects: SchemaProject[];
  definitions: SchemaDefinition[];
  definitionVersions: SchemaDefinition[];
  definition: SchemaDefinition;
  currentProject: SchemaProject;
  currentSchemas: Schema[];
  currentSchema: Schema;
  activeSchema: Schema;
  apiError: SchemaApiError;
}

export const initialState: SchemaState = {
  projects: [],
  definitions: [],
  definitionVersions: [],
  definition: null,
  currentProject: null,
  currentSchemas: null,
  currentSchema: null,
  activeSchema: null,
  apiError: null,
};

export const schemaReducer = createReducer(
  initialState,
  on(
    LoadSchemaProjects,
    LoadCurrentSchemaProject,
    LoadCurrentSchema,
    LoadActiveSchema,
    CreateSchema,
    CreateSchemaProject,
    DeleteSchemaProject,
    RemoveSchemaError,
    (state) => ({
      ...state,
      apiError: null,
    }),
  ),
  on(SetSchemaDefinitions, (state, { definitions }) => ({ ...state, definitions })),
  on(SetSchemaDefinitionVersions, (state, { definitionVersions }) => ({
    ...state,
    definitionVersions,
  })),
  on(SetSchemaDefinition, (state, { definition }) => ({ ...state, definition })),
  on(SetSchemaProjects, (state, { projects }) => ({ ...state, projects })),
  on(SetCurrentSchemaProject, (state, { project }) => ({ ...state, currentProject: project })),
  on(LoadCurrentSchemas, (state) => ({ ...state, currentSchemas: null, apiError: null })),
  on(SetCurrentSchemas, (state, { schemas }) => ({ ...state, currentSchemas: schemas })),
  on(SetCurrentSchema, (state, { schema }) => ({ ...state, currentSchema: schema })),
  on(SetActiveSchema, (state, { schema }) => ({ ...state, activeSchema: schema })),
  on(SetSchemaError, (state, { error }) => ({ ...state, apiError: error })),
);
